import { BridgeModelApi } from '@wiz-api/huizhou2-business'

const bridgeModelApi = new BridgeModelApi()

let cloudRender = null
let player = null

const setRootModelShow = async (show) => {
  const root = await player.Native.ModelTree.getRootItems()
  const rootList = root.map((val) => {
    return val.item
  })
  player.Native.ModelTree.setItemVisible(rootList, show)
  // const { data } = await this.cloudRender.Model.getAllInfo()
  // this.cloudRender.NodeProxy.setNodeVisible(data[0].dataInfo.nodeInstance, false)
}

const init = async (sourceId) => {
  setRootModelShow(false)
  const [err, res] = await bridgeModelApi.getList({
    sceneId: sourceId,
    skipCount: 0, // Number |
    maxResultCount: 999, // Number |
  })
  if (!err) {
    const params = []
    res.items.forEach((item) => {
      params.push({
        code: item.code,
      })
    })
    const codeRes = await player.Native.ModelTree.batchFindItemByCode(params)
    const visibleList = []
    codeRes.forEach((resItem) => {
      visibleList.push(resItem.item)
    })
    player.Native.ModelTree.setItemVisible(visibleList, true)
  }
}
// 创建
const create = async (propPlayer, sourceId, propCloudRender) => {
  if (!propPlayer.Native) {
    return
  }
  cloudRender = propCloudRender
  player = propPlayer
  // 初始化,设置隐藏显示
  init(sourceId)
}

const destroy = async (propPlayer) => {
  if (!propPlayer.Native) {
    return
  }
  await setRootModelShow(true)
  cloudRender = null
  player = null
}

const hidden = async () => {}

const display = async () => {}

export default { create, destroy, hidden, display }
